import { Header } from '@bp/ui-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MathplanJobsTable } from '../../../components/MathplanJobs/MathplanJobsTable';
import { Page } from '../../../components/Page/Page';
import { SolverInterfaceSettings } from '../../../components/Solver/SolverInterfaceSettings';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const MathplanSubpage: FC = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageAdministration()} title={t('routes.mathplan.title')}>
      <Header headline={t('solver.admin.title')} />
      <p className='mb-4'>{t('solver.admin.intro')}</p>
      <SolverInterfaceSettings />
      <Header headline={t('solver.admin.jobsTitle')} />
      <MathplanJobsTable />
    </Page>
  );
};
